import { render, staticRenderFns } from "./AsideContactPersons.vue?vue&type=template&id=1bff60f7&"
import script from "./AsideContactPersons.vue?vue&type=script&lang=js&"
export * from "./AsideContactPersons.vue?vue&type=script&lang=js&"
import style0 from "./AsideContactPersons.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports